import React from 'react';
import Styles from './index.less';
import { ITransitionItem } from '@framework/workbench/common/components/selectable-panel/transition-card/config';
import { TransitionType } from '@src/slide/domain/ui-model/element-modeles/transition/constants';
import Tooltip from '@tencent/dui/lib/components/Tooltip';

export interface ITransitionCardProps extends ITransitionItem {
    onClick: (type: TransitionType) => void;
    id: TransitionType;
}

export default class TransitionCard extends React.PureComponent<ITransitionCardProps> {
    public render() {
        const { tooltip } = this.props;
        return tooltip ?  (
            <Tooltip title={tooltip}>
                { this.renderCardContent() }
            </Tooltip>
        ) : this.renderCardContent();
    }

    private renderCardContent() {
        const { text, icon } = this.props;
        return (
            <div
                className={Styles['transition-card']}
                onClick={this.handleClick}
            >
                <img src={icon} className={Styles['transition-card-icon']} />
                <div className={Styles['transition-card-text']}>{text}</div>
            </div>
        );
    }

    private handleClick = () => {
        const { type } = this.props;
        this.props.onClick(type);
    };
}
